var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('PageSubmenu',{attrs:{"links":_vm.links}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }